import React from 'react';

import { useTranslation } from 'react-i18next';

import quickMatchStartImg from './imgs/clocks.webp';
import fairCompetitionsImg from './imgs/fair.webp';
import instantPayoutsImg from './imgs/instant.webp';
import antiCheatSystemImg from './imgs/shield.webp';
import styles from './Landing.module.scss';

export interface IFeatureProps {
  title: string;
  description: string;
  image: string;
}

export const Feature: React.FC<IFeatureProps> = ({
  description,
  image,
  title,
}) => {
  return (
    <div className={`${styles.featureCard}`}>
      <div className={styles.featureIcon}>
        <img alt={title} src={image} />
      </div>
      <h3 className={styles.featureTitle}>{title}</h3>
      <p
        className={styles.featureDescription}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

export const FairCompetitionsFeature: React.FC = () => {
  const { t } = useTranslation('landing');

  return (
    <Feature
      description={t('features.fairCompetitions.description')}
      image={fairCompetitionsImg}
      title={t('features.fairCompetitions.title')}
    />
  );
};

export const QuickMatchStartFeature: React.FC = () => {
  const { t } = useTranslation('landing');

  return (
    <Feature
      description={t('features.quickMatchStart.description')}
      image={quickMatchStartImg}
      title={t('features.quickMatchStart.title')}
    />
  );
};

export const InstantPayoutsFeature: React.FC = () => {
  const { t } = useTranslation('landing');

  return (
    <Feature
      description={t('features.instantPayouts.description')}
      image={instantPayoutsImg}
      title={t('features.instantPayouts.title')}
    />
  );
};

export const AntiCheatSystemFeature: React.FC = () => {
  const { t } = useTranslation('landing');

  return (
    <Feature
      description={t('features.antiCheatSystem.description')}
      image={antiCheatSystemImg}
      title={t('features.antiCheatSystem.title')}
    />
  );
};
